import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';

import { paginationModelState, loadingState } from '../state/RecoilState';
import { DataGrid } from '@mui/x-data-grid';
import { useRecoilState, useSetRecoilState } from 'recoil';
import RestUtilities from '../services/RestUtilities';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { colDateFormat } from '../Constants';

const BlogList = () => {
  const setLoading = useSetRecoilState(loadingState);
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] =
    useRecoilState(paginationModelState);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const getPosts = async () => {
      setLoading(true);
      const res = await RestUtilities.get('/api/blog/GetAll');
      setPosts(
        res.content.sort(
          (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
        )
      );
      setLoading(false);
    };
    if (posts.length === 0) {
      getPosts();
    }
  }, [posts, setLoading]);

  return (
    <Box>
      <Box my={1} display='flex' justifyContent={'space-between'} size='small'>
        <Typography variant='h5'>Blog Posts</Typography>
        <Button
          variant='contained'
          color='primary'
          onClick={() => navigate('/blogadd')}
          size='small'
          sx={{ ml: 2 }}
        >
          Add New Post
        </Button>
      </Box>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          rows={posts}
          getRowId={(row) => row.postRowId}
          columns={[
            {
              field: 'actions',
              headerName: 'Actions',
              sortable: false,
              width: 60,
              renderCell: (params) => (
                <div>
                  {!params.row.isFreeAction && (
                    <IconButton
                      onClick={(event) =>
                        navigate(`/blogcontent/${params.row.postRowId}`)
                      }
                    >
                      <Edit />
                    </IconButton>
                  )}
                </div>
              ),
            },
            { headerName: 'ID', field: 'postRowId', sortable: true, width: 60 },
            {
              headerName: 'Title',
              field: 'title',
              width: 200,
            },
            {
              headerName: 'Slug',
              field: 'slug',
              width: 300,
            },
            {
              headerName: 'Summary',
              field: 'description',
              width: 350,
            },
            {
              headerName: 'Published',
              field: 'isPublished',
              width: 80,
            },
            {
              headerName: 'DateCreated',
              field: 'dateCreated',
              width: 120,
              renderCell: (params) =>
                dayjs(params.row.dateCreated).format(colDateFormat),
            },
            {
              headerName: 'Author',
              field: 'author',
            },
          ]}
          getRowHeight={() => 'auto'}
          pageSizeOptions={[5, 10, 15, 25]}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </Box>
    </Box>
  );
};
export default BlogList;
